import React from 'react';
import styled from 'styled-components';
import MailIcon from '@narvar/nth-mail-icon';
import { HOME_PICKUP, LOCKER_DROPOFF } from '../../constants/returnMethods';
import Icon from '../Icon';

const InstructionNumber = styled.span`
  height: 2rem;
  width: 2rem;
  line-height: 1.8rem;
  position: absolute;
  border-radius: 50%;
  border: 2px solid black;
  top: 0;
  left: 0;
  font-weight: 700;
`;

const config = {
  [HOME_PICKUP]: {
    columns: [
      {
        icon: (
          <React.Fragment>
            <InstructionNumber>1</InstructionNumber>
            <div style={{ padding: '1.4rem' }}>
              <Icon.Calendar
                s={{
                  height: '3.9rem',
                }}
              />
            </div>
          </React.Fragment>
        ),
      },
      {
        icon: (
          <React.Fragment>
            <InstructionNumber>2</InstructionNumber>
            <MailIcon
              s={{
                width: '7rem',
              }}
              fillColor="transparent"
            />
          </React.Fragment>
        ),
      },
      {
        icon: (
          <React.Fragment>
            <InstructionNumber>3</InstructionNumber>
            <div style={{ padding: '0.35rem' }}>
              <Icon.Truck
                s={{
                  height: '6rem',
                }}
                noFill
              />
            </div>
          </React.Fragment>
        ),
      },
    ],
  },
  [LOCKER_DROPOFF]: {
    columns: [
      {
        icon: (
          <React.Fragment>
            <InstructionNumber>1</InstructionNumber>
            <Icon.MapWithPin
              s={{
                height: '4rem',
              }}
            />
          </React.Fragment>
        ),
      },
      {
        icon: (
          <React.Fragment>
            <InstructionNumber>2</InstructionNumber>
            <Icon.QRcode
              s={{
                height: '4rem',
              }}
            />
          </React.Fragment>
        ),
      },
      {
        icon: (
          <React.Fragment>
            <InstructionNumber>3</InstructionNumber>
            <Icon.Locker
              s={{
                height: '4rem',
              }}
              noFill
            />
          </React.Fragment>
        ),
      },
    ],
  },
};

export const learnMoreMethods = Object.keys(config);

const modalData = ({ optionId, language }) => {
  if (!learnMoreMethods.includes(optionId)) return null;
  return {
    infoColumns: Object.keys(config).includes(optionId)
      ? config[optionId].columns.map(({ icon }, i) => ({
          icon: icon || null,
          title:
            language[`returns.return_options.${optionId}.learn_more.section[${i}].title`] || '',
          description:
            language[`returns.return_options.${optionId}.learn_more.section[${i}].description`] ||
            '',
        }))
      : [],
    openText: language[`returns.return_options.${optionId}.learn_more.link_text`] || '',
    headerText: language[`returns.return_options.${optionId}.learn_more.title`] || '',
    description: language[`returns.return_options.${optionId}.learn_more.description`] || '',
    confirm: language[`returns.return_options.${optionId}.learn_more.button_text`] || '',
    disclaimer: language[`returns.return_options.${optionId}.learn_more.disclaimer`] || '',
  };
};

export default modalData;
